<template>
  <span class="popup-notification__icon">
    <svg class="s-icon">
      <use xlink:href="/img/svg/sprite1.svg#cart" />
    </svg>
  </span>
</template>
